export const visit = (vm, at) => {
at({ "en": { "forecast": { "quickFilters": { "forecastDealOwner": { "me": "Me" } }, "redirectButton": "Go to Forecast" } } });
};